import React from 'react'
import { Form, Select } from 'antd'

export const PREFERRED_PAYMENT_DAY_OPTIONS = [
  { value: 5, label: '05' },
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' }
] as const

export const KEEP_GRACE_PERIOD_VALUE = 'keep-grace-period' as const

export type PreferredPaymentDay = typeof PREFERRED_PAYMENT_DAY_OPTIONS[number]['value']
export type PreferredPaymentDayFormValue = PreferredPaymentDay | typeof KEEP_GRACE_PERIOD_VALUE

function isPreferredPaymentDay (value: number): value is PreferredPaymentDay {
  return PREFERRED_PAYMENT_DAY_OPTIONS.some(option => option.value === value)
}

export function preferredPaymentDayFromSimulation (
  value: number | string | undefined | null
): PreferredPaymentDayFormValue {
  if (value == null || value === KEEP_GRACE_PERIOD_VALUE) return KEEP_GRACE_PERIOD_VALUE

  const parsed = typeof value === 'number' ? value : Number(value)
  if (isPreferredPaymentDay(parsed)) return parsed

  return KEEP_GRACE_PERIOD_VALUE
}

export function preferredPaymentDayToApiParam (
  value: PreferredPaymentDayFormValue | undefined | null
): number | null {
  if (value == null || value === KEEP_GRACE_PERIOD_VALUE) return null
  return value
}

type Props = {
  disabled?: boolean
  onChange?: (value?: PreferredPaymentDayFormValue) => void
  showHint?: boolean
  variant?: 'simulator' | 'contract'
}

function PreferredPaymentDaySelect ({
  disabled,
  onChange,
  showHint = true,
  variant = 'simulator'
}: Props) {
  const isContract = variant === 'contract'

  return (
    <Form.Item
      name="preferredPaymentDay"
      initialValue={isContract ? KEEP_GRACE_PERIOD_VALUE : undefined}
      label={
        isContract
          ? <label>Melhor data para pagamento</label>
          : <label className="simulator-label">Melhor data para pagamento</label>
      }
      extra={showHint ? 'Se nenhuma data for selecionada, será aplicada a regra padrão de carência de 90 dias.' : undefined}
    >
      <Select<PreferredPaymentDayFormValue>
        allowClear={!isContract}
        disabled={disabled}
        placeholder={isContract ? 'Manter carência' : 'Selecione uma data (opcional)'}
        className={isContract ? undefined : 'unauth-inputs-center'}
        {...(onChange ? { onChange: (value) => onChange(value ?? undefined) } : {})}
      >
        {isContract && (
          <Select.Option value={KEEP_GRACE_PERIOD_VALUE}>
            Manter carência
          </Select.Option>
        )}
        {PREFERRED_PAYMENT_DAY_OPTIONS.map(option => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default PreferredPaymentDaySelect
